import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'
import {
  LANGUAGE_CODE_FRENCH,
  LANGUAGE_CODE_KOREAN,
  LANGUAGE_CODE_SPANISH,
} from '../utilities/language'

export const HOW_TO_BUILD_ARTICLE_TITLE: string =
  'How to Build Your Perfect Workplace with the Best Music Strategy'
export const HOW_TO_BUILD_ARTICLE_TITLE_ES: string =
  'Cómo crear tu lugar de trabajo ideal con la mejor estrategia musical'
export const HOW_TO_BUILD_ARTICLE_TITLE_FR: string =
  'Comment créer votre espace de travail idéal grâce à la meilleure stratégie musicale'
export const HOW_TO_BUILD_ARTICLE_TITLE_KO: string =
  '최적의 음악 전략을 통해 이상적인 작업 공간을 만드는 방법'

export const HOW_TO_BUILD_TITLE_HTML: JSX.Element = (
  <>How to Build Your Perfect Workplace with the Best Music Strategy</>
)
export const HOW_TO_BUILD_TITLE_HTML_ES: JSX.Element = (
  <>Cómo crear tu lugar de trabajo ideal con la mejor estrategia musical</>
)
export const HOW_TO_BUILD_TITLE_HTML_FR: JSX.Element = (
  <>
    Comment créer votre espace de travail idéal grâce à la meilleure stratégie
    musicale
  </>
)
export const HOW_TO_BUILD_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      최적의
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      음악
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      전략을
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      통해
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      이상적인
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      작업
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      공간을
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      만드는
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      방법
    </span>
  </>
)

export const HOW_TO_BUILD_PAGE_ID: string =
  '6787A61F-8BA3-4588-B51A-A6BED996CAD2'

export const HOW_TO_BUILD_ARTICLE_ROUTE: string =
  '/articles/how-to-build-your-perfect-workplace-with-the-best-music-strategy'
export const HOW_TO_BUILD_ARTICLE_ROUTE_ES: string =
  '/articles/how-to-build-your-perfect-workplace-with-the-best-music-strategy'
export const HOW_TO_BUILD_ARTICLE_ROUTE_FR: string =
  '/articles/how-to-build-your-perfect-workplace-with-the-best-music-strategy'
export const HOW_TO_BUILD_ARTICLE_ROUTE_KO: string =
  '/articles/how-to-build-your-perfect-workplace-with-the-best-music-strategy'

export const HOW_TO_BUILD_ARTICLE_URL: string =
  HOST + HOW_TO_BUILD_ARTICLE_ROUTE_ES
export const HOW_TO_BUILD_ARTICLE_URL_ES: string =
  HOST + '/' + LANGUAGE_CODE_SPANISH + HOW_TO_BUILD_ARTICLE_ROUTE_ES
export const HOW_TO_BUILD_ARTICLE_URL_FR: string =
  HOST + '/' + LANGUAGE_CODE_FRENCH + HOW_TO_BUILD_ARTICLE_ROUTE_FR
export const HOW_TO_BUILD_ARTICLE_URL_KO: string =
  HOST + '/' + LANGUAGE_CODE_KOREAN + HOW_TO_BUILD_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'background music streaming, workplace music, business background music, productivity, ambient music, reception area music, licensed music, coworking spaces, neuroscience of music, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'Música de fondo en streaming, música para el lugar de trabajo, música ambiental para empresas, mejora de la productividad, música ambiental, música para el sector hotelero, música con licencia, espacios de coworking, neurociencia musical, practical stream'
export const ARTICLE_KEYWORDS_FR =
  "Musique d'ambiance en streaming, musique pour le lieu de travail, musique d'ambiance pour entreprises, amélioration de la productivité, musique d'ambiance, musique pour l'hôtellerie, musique sous licence, espaces de coworking, neurosciences musicales, practical stream"
export const ARTICLE_KEYWORDS_KO =
  '배경 음악 스트리밍, 직장 음악, 비즈니스 배경 음악, 생산성 향상, 앰비언트 음악, 접객 공간 음악, 라이선스 음악, 코워킹 스페이스, 음악 신경과학, 실용적인 스트리밍'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A09B4581-C1B4-4909-AAB2-7365C2163F46.avif'
  : HOST + '/images/A09B4581-C1B4-4909-AAB2-7365C2163F46.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A09B4581-C1B4-4909-AAB2-7365C2163F46.jpg'
  : HOST + '/images/A09B4581-C1B4-4909-AAB2-7365C2163F46.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'C7632896-AECE-49A9-8C5A-FCB902D2E8A9.jpg'
  : HOST + '/images/C7632896-AECE-49A9-8C5A-FCB902D2E8A9.jpg'

export const HOW_TO_BUILD_JSON_LD_IMAGE_1200_X_1200: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A09B4581-C1B4-4909-AAB2-7365C2163F46.png'
  : HOST + '/images/A09B4581-C1B4-4909-AAB2-7365C2163F46.png'

export const SECOND_ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '6905FDBD-2AF5-4876-B84D-E1F8B5BFEF33.avif'
  : HOST + '/images/6905FDBD-2AF5-4876-B84D-E1F8B5BFEF33.avif'
export const SECOND_ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '6905FDBD-2AF5-4876-B84D-E1F8B5BFEF33.jpg'
  : HOST + '/images/6905FDBD-2AF5-4876-B84D-E1F8B5BFEF33.jpg'

export const ARTICLE_SUMMARY: string =
  'Whether you’re managing a traditional office, operating a coworking space, or leading a distributed remote team, this guide provides actionable strategies to transform sound design from theory into measurable results.'
export const ARTICLE_SUMMARY_ES: string =
  'Ya sea que gestione una oficina tradicional, opere un espacio de coworking o dirija un equipo remoto distribuido, esta guía le proporciona estrategias prácticas para transformar el diseño acústico de la teoría en resultados medibles.'
export const ARTICLE_SUMMARY_FR: string =
  'Que vous gériez un bureau traditionnel, un espace de coworking ou une équipe répartie à distance, ce guide vous propose des stratégies pratiques pour transformer la conception acoustique, de la théorie à des résultats concrets et mesurables.'
export const ARTICLE_SUMMARY_KO: string =
  '전통적인 사무실, 코워킹 스페이스 또는 분산된 원격 팀을 관리하든 관계없이, 이 가이드는 음향 설계를 이론에서 구체적이고 측정 가능한 결과로 전환하는 실용적인 전략을 제공합니다.'

export const HOW_TO_BUILD_ARTICLE_PUBLISHED_STR: string = '2025-12-17'
export const HOW_TO_BUILD_ARTICLE_CREATED_STR: string = '2025-12-17'
export const HOW_TO_BUILD_ARTICLE_PUBLISHED: Date = new Date(
  HOW_TO_BUILD_ARTICLE_PUBLISHED_STR
)
export const HOW_TO_BUILD_ARTICLE_CREATED: Date = new Date(
  HOW_TO_BUILD_ARTICLE_CREATED_STR
)
